export default function SvgBigLogo() {
  return (
    <svg
      width="942"
      height="731"
      viewBox="0 0 942 731"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M321.21 0.490756C321.517 0.797898 325.941 3.62361 330.979 6.75647C389.531 43.245 441.141 85.5079 479.848 128.692L483.657 132.992V66.465V-0.000673007H402.126C357.275 -0.000673007 320.841 0.245041 321.21 0.490756Z"
        fill="url(#paint0_linear_850_1416)"
      />
      <path
        d="M510.691 72.0565C510.753 121.015 510.876 134.038 511.49 133.239C511.92 132.748 527.526 114.012 546.204 91.6522C564.882 69.3536 580.242 50.8022 580.242 50.5565C580.303 50.3108 569.981 44.1065 557.324 36.7965C544.668 29.5479 529.001 20.5179 522.549 16.7708L510.691 9.89078V72.0565Z"
        fill="url(#paint1_linear_850_1416)"
      />
      <path
        d="M311.01 16.5857C336.016 39.4986 348.366 52.5214 365.446 73.8371C402.371 119.909 428.606 173.167 439.973 224.829C442.123 234.596 443.905 245.284 445.318 256.771C446.67 268.013 447.161 297.744 446.178 309.17C443.352 342.526 434.013 374.284 416.871 408.5C401.143 440.013 381.605 469.56 344.556 517.843C290.059 588.854 272.364 614.163 253.748 647.457C239.371 673.196 226.96 702.436 220.201 726.577L218.973 731H302.101H385.291L385.66 727.437C386.52 720.434 389.162 707.841 391.804 698.811C397.026 680.629 403.723 664.35 416.134 639.471C426.394 618.893 433.644 605.931 457.115 565.757C515.483 465.997 536.004 418.206 543.069 365.5C544.605 353.767 544.605 324.527 543.069 312.364C536.127 258.307 511.735 205.97 468.727 152.773C431.125 106.271 374.969 56.6986 319.919 21.5C308.921 14.4357 308.245 14.0671 311.01 16.5857Z"
        fill="url(#paint2_linear_850_1416)"
      />
      <path
        d="M574.835 99.6371C558.676 118.987 538.401 143.19 529.861 153.387L514.316 172L519.477 179.801C533.609 201.301 544.852 222.679 552.716 242.95C554.314 247.004 555.85 250.936 556.157 251.673C556.649 252.901 557.57 252.164 567.339 242.213C598.244 210.823 643.279 169.666 686.717 133.054C692.739 127.956 698.637 122.919 699.743 121.936L701.77 120.093L653.785 92.45C627.428 77.2157 605.494 64.7457 605.063 64.6228C604.633 64.5 590.994 80.2871 574.835 99.6371Z"
        fill="url(#paint3_linear_850_1416)"
      />
      <path
        d="M355.247 97.8557C355.247 97.9786 356.291 100.559 357.582 103.569C368.579 128.939 378.84 166.963 383.141 198.107C385.721 217.027 386.213 224.337 386.213 243.564C386.213 263.221 385.66 269.979 382.526 285.336C374.785 323.606 355.984 360.831 324.465 400.514C311.747 416.547 300.258 429.14 278.815 450.64C252.273 477.116 233.718 493.947 180.45 539.957C105.001 605.071 71.6392 637.076 40.489 674.486C27.0337 690.641 10.1376 714.107 1.41312 728.666L0 731H91.6072C178.361 731 183.276 730.939 183.645 729.894C198.759 687.509 219.71 645.983 245.945 606.607C263.885 579.64 276.603 562.993 317.154 513.543C347.567 476.44 361.759 457.643 374.416 437.863C400.835 396.46 414.721 358.374 420.128 312.057C421.479 300.631 421.971 269.733 420.988 259.167C416.564 210.454 395.429 155.906 361.821 106.394C356.967 99.2071 355.247 96.9957 355.247 97.8557Z"
        fill="url(#paint4_linear_850_1416)"
      />
      <path
        d="M226.222 143.928C168.591 165.613 120.729 183.673 119.931 184.041C118.517 184.655 118.825 184.84 123.924 186.375C164.475 198.6 199.496 215.861 227.144 237.238C236.298 244.364 253.931 261.81 260.137 269.98C276.91 292.155 286.31 314.208 290.55 341.544C291.41 347.134 291.656 352.171 291.594 366.115C291.594 381.903 291.41 384.667 289.935 394.495C288.031 407.027 288.092 406.228 288.891 405.737C289.997 405.061 308.675 381.473 314.204 373.733C347.996 326.678 360.714 291.234 361.82 240.801C362.435 212.483 359.916 190.245 352.666 161.251C347.136 139.014 334.479 104.307 331.96 104.491C331.407 104.553 283.853 122.305 226.222 143.928Z"
        fill="url(#paint5_linear_850_1416)"
      />
      <path
        d="M712.52 146.63C651.018 198.475 601.866 244.117 567.46 281.342L565.432 283.492L566.968 290.864C570.409 307.757 571.207 316.234 571.207 338.778C571.207 355.425 570.962 361.384 570.102 368.264C565.371 404.814 553.267 442.162 531.886 486.33L526.172 498.124L528.384 501.072C536.555 511.945 549.703 525.152 565.248 538.052C575.508 546.591 594.985 561.518 595.353 561.15C595.476 561.088 594.985 559.122 594.309 556.911C590.315 543.95 588.104 527.671 587.673 508.321C587.305 492.104 587.981 484.364 590.93 471.157C605.245 406.78 665.027 334.601 766.28 259.412C787.968 243.318 815.862 224.337 837.98 210.638C843.141 207.444 847.381 204.741 847.381 204.557C847.381 204.004 727.695 135.142 726.835 135.204C726.405 135.204 719.954 140.364 712.52 146.63Z"
        fill="url(#paint6_linear_850_1416)"
      />
      <path
        d="M159.005 232.323C170.986 246.698 178.113 260.826 181.185 276.306C182.475 283.186 182.475 299.526 181.124 310.276C179.096 326.248 176.516 336.261 167.3 364.026C156.978 395.048 155.012 404.385 154.52 424.533C153.844 451.193 157.776 468.516 169.819 491.736C172.952 497.695 179.219 507.708 179.772 507.585C181.124 507.278 221.92 471.895 239.246 455.985L249.445 446.525L252.64 436.881C260.443 413.169 263.945 394.249 264.744 371.336C265.727 341.728 259.153 317.156 244.1 294.489C227.634 269.672 203.058 249.831 166.87 232.078C160.111 228.761 154.336 226.058 154.151 226.058C153.906 226.058 156.118 228.883 159.005 232.323Z"
        fill="url(#paint7_linear_850_1416)"
      />
      <path
        d="M684.197 366.913C651.572 402.173 631.42 433.133 621.221 463.724C615.875 479.941 614.155 491.674 614.708 509.243C615.63 538.913 621.774 560.843 634.492 580.193C641.987 591.557 647.947 598.13 676.824 626.879C710.186 660.05 718.972 669.756 733.84 689.843C742.135 701.084 753.133 717.977 758.908 728.359L760.382 731H851.191C901.142 731 941.999 730.877 941.999 730.693C941.999 730.017 933.336 716.81 928.667 710.237C917.546 694.757 906.426 681.734 891.373 666.807C869.869 645.43 849.286 628.721 804.066 595.857C764.13 566.863 748.832 554.516 731.813 537.5C713.995 519.686 704.841 507.4 695.932 489.279C685.487 467.963 681.37 450.21 681.309 425.7C681.248 405.49 684.32 385.833 691.017 363.719C691.877 360.893 692.491 358.497 692.368 358.374C692.307 358.313 688.62 362.121 684.197 366.913Z"
        fill="url(#paint8_linear_850_1416)"
      />
      <path
        d="M505.776 535.596C502.274 541.861 492.321 559.246 483.535 574.173C474.811 589.161 467.684 601.631 467.684 602C467.684 603.044 475.241 610.661 483.044 617.541C487.283 621.227 499.571 630.933 510.384 639.041C521.198 647.211 532.687 656.057 535.882 658.76C559.844 678.847 575.634 698.259 587.799 722.707L591.916 731H660.421H728.866L728.128 729.587C726.285 726.147 716.209 711.466 709.696 702.743C698.821 688.246 688.254 676.206 672.955 660.91C649.854 637.874 636.214 626.449 590.257 591.557C562.854 570.733 554.068 563.853 542.149 553.594C533.793 546.407 520.645 533.753 515.177 527.61L512.166 524.109L505.776 535.596Z"
        fill="url(#paint9_linear_850_1416)"
      />
      <path
        d="M449.25 634.066C443.229 645.123 432.477 667.299 428.422 676.82C421.233 693.774 415.458 712.571 413.369 725.594L412.57 731H487.159H561.808L559.842 727.437C553.391 715.889 543.868 703.357 533.73 693.221C524.699 684.191 518.186 678.786 496.252 662.384C476.468 647.519 466.638 639.533 458.712 631.977C455.947 629.336 453.551 627.186 453.367 627.186C453.182 627.186 451.278 630.319 449.25 634.066Z"
        fill="url(#paint10_linear_850_1416)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_850_1416"
          x1="321.207"
          y1="66.4958"
          x2="483.657"
          y2="66.4958"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BE1B86" />
          <stop
            offset="1"
            stopColor="#2B306C"
          />
        </linearGradient>
        <linearGradient
          id="paint1_linear_850_1416"
          x1="510.691"
          y1="71.5821"
          x2="580.242"
          y2="71.5821"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BE1B86" />
          <stop
            offset="1"
            stopColor="#2B306C"
          />
        </linearGradient>
        <linearGradient
          id="paint2_linear_850_1416"
          x1="218.973"
          y1="373.083"
          x2="544.221"
          y2="373.083"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BE1B86" />
          <stop
            offset="1"
            stopColor="#2B306C"
          />
        </linearGradient>
        <linearGradient
          id="paint3_linear_850_1416"
          x1="514.316"
          y1="158.372"
          x2="701.77"
          y2="158.372"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BE1B86" />
          <stop
            offset="1"
            stopColor="#2B306C"
          />
        </linearGradient>
        <linearGradient
          id="paint4_linear_850_1416"
          x1="0"
          y1="414.34"
          x2="421.505"
          y2="414.34"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BE1B86" />
          <stop
            offset="1"
            stopColor="#2B306C"
          />
        </linearGradient>
        <linearGradient
          id="paint5_linear_850_1416"
          x1="119.203"
          y1="255.226"
          x2="361.909"
          y2="255.226"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BE1B86" />
          <stop
            offset="1"
            stopColor="#2B306C"
          />
        </linearGradient>
        <linearGradient
          id="paint6_linear_850_1416"
          x1="526.172"
          y1="348.18"
          x2="847.381"
          y2="348.18"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BE1B86" />
          <stop
            offset="1"
            stopColor="#2B306C"
          />
        </linearGradient>
        <linearGradient
          id="paint7_linear_850_1416"
          x1="154.133"
          y1="366.822"
          x2="264.839"
          y2="366.822"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BE1B86" />
          <stop
            offset="1"
            stopColor="#2B306C"
          />
        </linearGradient>
        <linearGradient
          id="paint8_linear_850_1416"
          x1="614.609"
          y1="544.687"
          x2="941.999"
          y2="544.687"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BE1B86" />
          <stop
            offset="1"
            stopColor="#2B306C"
          />
        </linearGradient>
        <linearGradient
          id="paint9_linear_850_1416"
          x1="467.684"
          y1="627.554"
          x2="728.866"
          y2="627.554"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BE1B86" />
          <stop
            offset="1"
            stopColor="#2B306C"
          />
        </linearGradient>
        <linearGradient
          id="paint10_linear_850_1416"
          x1="412.57"
          y1="679.093"
          x2="561.808"
          y2="679.093"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BE1B86" />
          <stop
            offset="1"
            stopColor="#2B306C"
          />
        </linearGradient>
      </defs>
    </svg>
  );
}
